export const generateNumericInputPlaceholder = (
  range = {}
) => {
  const min = range?.min
  const max = range?.max

  let placeholder = ''

  if (min !== '' && !isNaN(min) && min !== null) {
    placeholder += `Minimo: ${min}`
  }

  if (max !== '' && !isNaN(max) && max !== null) {
    placeholder += (placeholder ? ' - ' : '') + `Massimo: ${max}`
  }

  return placeholder
}

export const sanitizeNumericInput = (event, inputVal) => {
  if (event.key === '+' || event.key === 'e') {
    event.preventDefault()
  }

  if (event.key === '-' && inputVal < 0) {
    event.preventDefault()
  }
}
